<template>
    <div class="card-container">
        <common-top-form
            selectShowPower="/apppointsshopmanage/select"
            :model="formModel"
            :submitService="submitService"
            :submitData="submitData"
            @success="onSuccess"
            @openAddDialog="openAddDialog"
            addShowPower="/apppointsshopmanage/add"
        >
            <el-form-item label="名称" prop="name">
                <el-input
                    type="text"
                    maxlength="20"
                    v-model="formModel.name"
                    placeholder="请输入名称"
                ></el-input>
            </el-form-item>
            <!--<el-form-item label="支付方式">-->
            <!--<el-select v-model="formModel.payTypeScope">-->
            <!--<el-option-->
            <!--v-for="item in payTypeScope"-->
            <!--:key="item.dictKey"-->
            <!--:label="item.dictValue"-->
            <!--:value="item.dictKey"-->
            <!--&gt;-->
            <!--</el-option>-->
            <!--</el-select>-->
            <!--</el-form-item>-->
        </common-top-form>
        <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
            <el-table-column
                prop="weight"
                label="权重"
                min-width="120"
                :formatter="formatterTableData"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="goodName"
                label="名称"
                min-width="220"
                :formatter="formatterTableData"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="type"
                label="类别"
                min-width="220"
                :formatter="formatterTableDataType"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="typeTwo"
                label="类别详情"
                min-width="220"
                :formatter="formatterTableDataTypeTwo"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="artNo"
                label="货号"
                min-width="220"
                :formatter="formatterTableData"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="residueNo"
                label="库存"
                min-width="220"
                :formatter="formatterTableData"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="price"
                label="交易积分"
                min-width="120"
                :formatter="formatterTableNumberYuan"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="signPrice"
                label="签到积分"
                min-width="120"
                :formatter="formatterTableNumberYuan"
                show-overflow-tooltip
            ></el-table-column>

            <!--<el-table-column-->
            <!--prop="payTypeScope"-->
            <!--label="支付方式"-->
            <!--min-width="120"-->
            <!--:formatter="formatterTablepayTypeScope"-->
            <!--show-overflow-tooltip-->
            <!--&gt;</el-table-column>-->

            <el-table-column prop="imgUrl" label="图片" min-width="120">
                <template slot-scope="scope">
                    <image-viewer
                        class="iconUrl"
                        :src="scope.row.imgUrl"
                        alt="图片描述"
                    ></image-viewer>
                </template>
            </el-table-column>
            <el-table-column prop="otherImgsUrl" label="其他图片" min-width="400">
                <template slot-scope="scope">
                    <div class="alliconUrl" v-if="scope.row.otherImgsUrl">
                        <div v-for="(image, index) in scope.row.otherImgsUrl.split(',')" :key="image" v-show="index < 3">
                            <img class="iconUrl" :src="image" v-show="image.slice(image.length-3, image.length) != 'mp4'" alt=""/>
                            <video class="iconUrl" :src="image" v-show="image.slice(image.length-3, image.length) == 'mp4'"/>
                        </div>
                    </div>
                    <div v-else>暂无其他图片!</div>
                </template>
            </el-table-column>
            <el-table-column
                prop="status"
                label="状态"
                min-width="100"
                show-overflow-tooltip
            >
                <template slot-scope="scope">
                    <el-switch
                        v-model="scope.row.status"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        active-value="1"
                        inactive-value="0"
                        @change="statusturns($event, scope.row)"
                    />
                </template>
            </el-table-column>
            <el-table-column
                prop="remark"
                label="备注"
                min-width="200"
                :formatter="formatterTableData"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="createTime"
                label="创建时间"
                min-width="180"
                :formatter="formatterTableData"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="updateTime"
                label="修改时间"
                min-width="180"
                :formatter="formatterTableData"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="modifier"
                label="操作人"
                min-width="120"
                :formatter="formatterTableData"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                v-if="
          hasPerm('/apppointsshopmanage/update') ||
          hasPerm('/apppointsshopmanage/del')
        "
                label="操作"
                min-width="260"
                fixed="right"
            >
                <template slot-scope="scope">
                    <el-button
                        type="text"
                        v-if="hasPerm('/apppointsshopmanage/update')"
                        @click="openAddDialog(scope.row)"
                    >修改
                    </el-button>
                    <el-button
                        type="text"
                        v-if="hasPerm('/apppointsshopmanage/del')"
                        @click="handleDelete(scope.row)"
                    >删除
                    </el-button>
                </template>
            </el-table-column>
        </common-table>
        <form-dialog
            ref="formDialog"
            :formDialogTitle="itemId ? '修改' : '添加'"
            :model="dialogModel"
            :submitData="dialogData"
            :rules="dialogRules"
            :dialogService="dialogService"
            @close="dialogClose"
            @success="dialogSuccess"
            class="note"
            labelWidth="120px"
            dialogWidth="439px"
        >
            <el-form-item label="类型" prop="type">
                <el-select style="width: 198px" v-model="dialogModel.type">
                    <el-option
                        v-for="item in typeList"
                        :key="item.dictKey"
                        :label="item.dictValue"
                        :value="item.dictKey"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="优惠券" label-width="135px" prop="couponGroupId" v-if="dialogModel.type == 3">
                <el-select v-model="dialogModel.couponGroupId" placeholder="请选择" style="width: 198px">
                    <el-option
                        v-for="item in couponList"
                        :key="item.id"
                        :label="item.groupName"
                        :value="item.id"
                        style="width: 250px"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="商品类型" prop="typeTwo" v-if="dialogModel.type == 2">
                <el-select style="width: 198px" v-model="dialogModel.typeTwo">
                    <el-option
                        v-for="item in typeTwoList"
                        :key="item.dictKey"
                        :label="item.dictValue"
                        :value="item.dictKey"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="权重" prop="weight">
                <el-input-number
                    v-model="dialogModel.weight"
                    :min="0"
                    :max="999999999"
                    :step="0"
                    :precision="0"
                    :controls="false"
                    placeholder="请输入"
                ></el-input-number>
            </el-form-item>

            <el-form-item label="名称" prop="goodName">
                <el-input
                    type="text"
                    maxlength="20"
                    v-model="dialogModel.goodName"
                    placeholder="请输入名称"
                    style="width: 180px"
                ></el-input>
            </el-form-item>
            <el-form-item label="货号" prop="artNo">
                <el-input
                    type="text"
                    maxlength="20"
                    v-model="dialogModel.artNo"
                    placeholder="请输入名称"
                    style="width: 180px"
                ></el-input>
            </el-form-item>
            <el-form-item label="库存" prop="residueNo">
                <el-input-number
                    v-model="dialogModel.residueNo"
                    :min="1"
                    :max="999999999"
                    :step="1"
                    :precision="0"
                    :controls="false"
                    placeholder="请输入"
                ></el-input-number>
            </el-form-item>
            <el-form-item label="交易积分" prop="price">
                <el-input-number
                    v-model="dialogModel.price"
                    :min="0"
                    :max="999999999"
                    :step="0.1"
                    :precision="2"
                    :controls="false"
                    placeholder="请输入"
                ></el-input-number>
            </el-form-item>
            <el-form-item label="签到积分" prop="signPrice">
                <el-input-number
                    v-model="dialogModel.signPrice"
                    :min="0"
                    :max="999999999"
                    :step="0.1"
                    :precision="2"
                    :controls="false"
                    placeholder="请输入"
                ></el-input-number>
            </el-form-item>
            <!--<el-form-item label="支付方式" prop="payTypeScope">-->
            <!--<el-select style="width: 198px" v-model="dialogModel.payTypeScope">-->
            <!--<el-option-->
            <!--v-for="item in payTypeScope.slice(1, payTypeScope.length)"-->
            <!--:key="item.dictKey"-->
            <!--:label="item.dictValue"-->
            <!--:value="item.dictKey"-->
            <!--&gt;-->
            <!--</el-option>-->
            <!--</el-select>-->
            <!--</el-form-item>-->

            <el-form-item label="图片" prop="imgUrl">
                <el-upload
                    class="avatar-uploader"
                    :action="uploadUrl + '8883/picture/upload'"
                    :data="commonParams"
                    name="picture"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :before-upload="beforeAvatarUpload"
                >
                    <img
                        v-if="dialogModel.imgUrl"
                        :src="dialogModel.imgUrl"
                        class="avatar"
                    />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
            </el-form-item>
            <el-form-item label="其他图片" prop="otherImgsUrl"  v-loading="loading">
                <el-upload
                    :action="uploadUrl + '8883/picture/upload'"
                    list-type="picture-card"
                    :data="commonParams"
                    name="picture"
                    :multiple="true"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess1"
                    :before-upload="beforeAvatarUploadOther"
                    :on-error="otherError"
                >
                    <i class="el-icon-folder-add"></i>
                </el-upload>
                <div class="newimg">
                    <div v-for="url in dialogModel.otherImgsUrl" :key="url">
                        <img @click="handleImgClick(url)" :src="url" class="newavatar"
                             v-show="url.slice(url.length-3, url.length) != 'mp4'"/>
                        <video @click="handleImgClick(url)" :src="url" class="newavatar"
                               v-show="url.slice(url.length-3, url.length) == 'mp4'"/>
                    </div>
                </div>
            </el-form-item>
            <el-form-item label="备注" prop="remark">
                <el-input
                    v-model="dialogModel.remark"
                    maxlength="200"
                    show-word-limit
                    type="textarea"
                    rows="3"
                ></el-input>
            </el-form-item>
        </form-dialog>
    </div>
</template>

<script>
    import CommonTopForm from "components/common/CommonTopForm";
    import CommonTable from "components/common/CommonTable";
    import FormDialog from "../../dialog/FormDialog";
    import ImageViewer from "../../dialog/ImageViewer";

    import ShopService from "service/ShopService";
    import TransactionService from "service/TransactionService";

    import Server from "common/conf/Server";
    import SelectLevel from "components/business/SelectLevel";
    import privateKey from "service/constant/privateKey";
    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin, dialogMixin, validatorsMixin} from "mixin";
    import {mapGetters} from "vuex";

    export default {
        name: "apppointsshopmanage",
        components: {
            CommonTopForm,
            CommonTable,
            FormDialog,
            SelectLevel,
            ImageViewer,
        },
        data() {
            return {
                uploadUrl: Server[process.env.NODE_ENV],
                show: false,
                formModel: {
                    name: "",
                    payTypeScope: "",
                },
                tableData: [],
                submitService: ShopService.apppointsshopmanageList,
                page: {},
                isPage: false,
                itemId: "",
                dialogModel: {
                    type: "",
                    typeTwo: "",
                    artNo: 1,
                    weight: 0,
                    goodName: "",
                    residueNo: 1,
                    price: undefined,
                    signPrice: undefined,
                    payTypeScope: "",
                    imgUrl: "",
                    otherImgsUrl: [],
                    remark: "",
                    couponGroupId: "",
                },
                payTypeScope: [
                    {
                        dictKey: "",
                        dictValue: "全部",
                    },
                ],
                dialogRules: {
                    type: [
                        {
                            required: true,
                            message: "请输入",
                        },
                    ],
                    typeTwo: [
                        {
                            required: true,
                            message: "请输入",
                        },
                    ],
                    artNo: [
                        {
                            required: true,
                            message: "请输入",
                        },
                    ],
                    goodName: [
                        {
                            required: true,
                            message: "请输入",
                        },
                    ],
                    residueNo: [
                        {
                            required: true,
                            message: "请输入",
                        },
                    ],
                    payTypeScope: [
                        {
                            required: true,
                            message: "请选择",
                        },
                    ],
                    price: [
                        {
                            required: true,
                            message: "请输入",
                        },
                    ],
                    signPrice: [
                        {
                            required: true,
                            message: "请输入",
                        },
                    ],
                    couponGroupId: [
                        {
                            required: true,
                            message: "请输入",
                        },
                    ],
                    imgUrl: [
                        {
                            required: true,
                            message: "请选择你要上传的图片",
                        },
                    ],
                },
                typeList: [
                    {
                        dictKey: '1',
                        dictValue: '每月推荐'
                    },
                    {
                        dictKey: '2',
                        dictValue: '积分精品'
                    },
                    {
                        dictKey: '3',
                        dictValue: '优惠券'
                    },
                ],
                typeTwoList: [],
                isFlag: false,
                checkAll: false,
                checkedCities: [],
                couponList: [],
                loading: false
            };
        },
        inject: ["reload"],
        mixins: [loadMixin, dialogMixin, validatorsMixin],
        mounted() {
            this.load();
            this.getTypeNames("merchantPayType", (res) => {
                this.payTypeScope = [...this.payTypeScope, ...res];
            });
            this.getTypeNames("积分精品商城", (res) => {
                this.typeTwoList = res;
            });
        },
        computed: {
            submitData() {
                this.params = {
                    name: this.formModel.name,
                    payTypeScope: this.formModel.payTypeScope,
                    current: this.isPage ? this.page.currentPage : 1,
                    size: this.page.pageSize,
                };
                return this.params;
            },
            dialogData() {
                const params = {
                    weight: this.dialogModel.weight,
                    type: this.dialogModel.type,
                    artNo: this.dialogModel.artNo,
                    goodName: this.dialogModel.goodName,
                    residueNo: this.dialogModel.residueNo,
                    price: this.dialogModel.price,
                    signPrice: this.dialogModel.signPrice,
                    payTypeScope: this.dialogModel.payTypeScope,
                    imgUrl: this.dialogModel.imgUrl,
                    remark: this.dialogModel.remark,
                    otherImgsUrl: this.dialogModel.otherImgsUrl
                        ? this.dialogModel.otherImgsUrl.join(",")
                        : "",
                };
                if (this.dialogModel.type == 2) {
                    params.typeTwo = this.dialogModel.typeTwo;
                }
                if (this.dialogModel.type == 3 && this.dialogModel.couponGroupId) {
                    params.couponGroupId = this.dialogModel.couponGroupId;
                    const couponGroupName = this.couponList.find(item => item.id == this.dialogModel.couponGroupId).groupName;
                    params.couponGroupName = couponGroupName;
                }
                if (this.itemId) {
                    params.id = this.itemId;
                }
                return params;
            },
            dialogService() {
                return this.itemId
                    ? ShopService.apppointsshopmanageEdit
                    : ShopService.apppointsshopmanageInsert;
            },
            commonParams() {
                const params = {
                    serverType: this.serverType,
                    tatId: this.tatId,
                    reqTime: new Date().format("yyyy-MM-dd HH:mm:ss"),
                };
                params.sign = encrypt(
                    urlEncode(objKeySort(params)) + "&priKey=" + privateKey.priKey
                );
                return params;
            },
            ...mapGetters(["serverType", "tatId", "userId"]),
        },
        watch: {},
        methods: {
            load() {
                this.formModel = {
                    payTypeScope: "",
                };
                this.page = this.$refs.commonTable.page;
                this.getList();
                this.getCouponList();
            },
            getCouponList() {
                this.doLoad(TransactionService.coupongroupmanageList, {
                        size: 100
                    },
                    (res) => {
                        this.couponList = res.contents.rows;
                    },
                    "信息获取失败"
                );
            },
            getPage() {
                this.isPage = true;
                this.getList();
            },
            getList() {
                this.doLoad(
                    this.submitService,
                    this.submitData,
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.onSuccess(res);
                            this.isPage = false;
                        });
                    },
                    "信息获取失败"
                );
            },
            handleDelete(item) {
                this.showConfirm("是否删除？")
                    .then(() => {
                        this.doDelete(item.id);
                    })
                    .catch(() => {
                    });
            },
            doDelete(id) {
                this.doLoad(
                    ShopService.apppointsshopmanageDel,
                    {
                        id: id,
                    },
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.commonSuccess(res);
                        });
                    },
                    "操作失败"
                );
            },
            statusturns($event, scope) {
                this.doStatus($event, scope);
            },
            doStatus($event, scope) {
                this.doLoad(
                    ShopService.apppointsshopmanageStatus,
                    {
                        id: scope.id,
                        status: $event,
                    },
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.commonSuccess(res);
                        });
                    },
                    "操作失败"
                );
            },
            openAddDialog(item, flag) {
                this.itemId = item ? item.id : "";
                if (this.itemId) {
                    this.isFlag = true;
                    this.dialogModel = JSON.parse(JSON.stringify(item));
                    this.dialogModel.couponGroupId = Number(this.dialogModel.couponGroupId)
                    if (!this.dialogModel.otherImgsUrl) {
                        this.dialogModel.otherImgsUrl = [];
                    } else {
                        this.dialogModel.otherImgsUrl =
                            this.dialogModel.otherImgsUrl.split(",");
                    }
                }
                this.$refs.formDialog.open();
            },
            dialogClose() {
                this.dialogModel = {
                    weight: 0,
                    goodName: "",
                    residueNo: 1,
                    artNo: 1,
                    price: undefined,
                    payTypeScope: undefined,
                    imgUrl: "",
                    otherImgsUrl: [],
                    remark: "",
                };
                this.itemId = "";
            },
            dialogSuccess(res) {
                this.commonSuccess(res);
                this.$refs.formDialog.closeDialog();
            },
            commonSuccess(res) {
                this.showSuccess(res.respMsg);
                this.getList();
            },
            onSuccess(res) {
                this.doCheck(res, (res) => {
                    const result = res.contents;
                    this.tableData = result.rows;
                    this.page.currentPage = result.current;
                    this.page.total = result.total;
                    this.page.pageSize = result.size;
                });
            },
            handleAvatarSuccess(res, file) {
                this.doCheck(res, (res) => {
                    this.dialogModel.imgUrl = res.contents;
                });
            },
            beforeAvatarUpload(file) {
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isLt2M) {
                    this.$message.error("上传图片大小不能超过 2MB!");
                    return isLt2M;
                }
                return isLt2M;
            },
            beforeAvatarUploadOther(file) {
                this.loading = true
                console.log(file)
                const isVideo = file.type === 'video/mp4';

                const isLt2M = file.size / 1024 / 1024 < 12;
                console.log(isVideo && !isLt2M, isVideo, !isLt2M)
                if (isVideo && !isLt2M) {
                    this.loading = false
                    this.$message.error("上传视频大小不能超过 12MB!");
                    return isLt2M;
                }
                return isLt2M;
            },
            otherError(){
                this.loading = false
            },
            formatterTableDataTypeTwo(row, column, cellValue, index) {
                let value = "--";
                if (row.type == 3) {
                    return row.couponGroupName ? row.couponGroupName : value;
                }
                if (row.type == 2) {
                    return cellValue ? cellValue : value;
                }
                return value;
            },
            formatterTableDataType(row, column, cellValue, index) {
                let value = "--";
                this.typeList.forEach((item) => {
                    if (item.dictKey == cellValue) {
                        value = item.dictValue;
                    }
                });
                return value;
            },
            handleAvatarSuccess1(res, file) {
                this.doCheck(res, (res) => {
                    this.dialogModel.otherImgsUrl.push(res.contents);
                    this.loading = false
                });
            },
            handleImgClick(url) {
                this.dialogModel.otherImgsUrl = this.dialogModel.otherImgsUrl.filter(
                    (item) => item !== url
                );
            },
        },
    };
</script>

<style scoped>
    .button {
        width: 50px;
        padding: 11px 10px;
        margin-left: 49px;
        display: block;
        float: left;
    }

    .text {
        width: 145px !important;
        margin-left: 12px;
        float: left;
    }

    .mem-name p {
        margin-bottom: 20px;
        vertical-align: middle;
        line-height: 40px;
        color: rgba(170, 170, 170, 1);
    }

    .mem-name p:first-child {
        display: inline-block;
        width: 90px;
        text-align: right;
        vertical-align: middle;
        font-size: 14px;
        color: #606266;
        line-height: 40px;
    }

    .chenk {
        width: 60px;
        position: relative;
        top: -61px;
        left: 189px;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409eff;
    }

    .avatar {
        width: 100px;
        height: 100px;
        display: block;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 100px;
        height: 100px;
        line-height: 100px;
        text-align: center;
    }

    .iconUrl {
        width: 50px;
        height: 50px;
        margin: auto;
        overflow: hidden;
    }

    .alliconUrl {
        /* width: 50px;
        height: 50px; */
        display: flex;
        overflow: hidden;
        justify-content: center;
        align-items: center;
    }

    /deep/ .el-upload--picture-card {
        /* background-color: #fbfdff; */
        border: 0px dashed #c0ccda;
        border-radius: 6px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        width: 35px !important;
        height: 35px !important;
        line-height: 35px !important;
        vertical-align: top;
    }

    /deep/ .el-upload--picture-card i {
        font-size: 40px;
        color: #8c939d;
    }

    .newimg {
        display: flex;
        flex-wrap: wrap;
    }

    .newimg div:nth-child(2) {
        margin: 0px 10px 10px 10px;
    }

    .newimg div:nth-child(5) {
        margin: 0px 10px 10px 10px;
    }

    .newimg div:nth-child(8) {
        margin: 0px 10px 10px 10px;
    }

    .newimg div:nth-child(11) {
        margin: 0px 10px 10px 10px;
    }

    .newavatar {
        width: 70px;
        height: 70px;
        display: block;
        border: 1px dashed #c0ccda;
        border-radius: 6px;
        cursor: pointer;
    }

    .newavatar:hover {
        width: 70px;
        height: 70px;
        border: 1px dashed red;
        border-radius: 6px;
    }

    .iconUrl {
        width: 50px;
        height: 50px;
        margin: 5px 5px 0px 5px;
        overflow: hidden;
    }
</style>



// WEBPACK FOOTER //
// src/view/page/AppManager/AppPointsShopManage.vue